import { Routes, Route } from "react-router-dom";
import { guestRoutes } from "./AppConfig";

const renderRoutes = (routes) =>
  routes.map(({ id, path, element, index, children }) => {
    if (index) {
      return <Route key={id} index element={element} />;
    } else {
      return (
        <Route key={id} path={path} element={element}>
          {children ? renderRoutes(children) : null}
        </Route>
      );
    }
  });

const AppGuest = () => {
  return <Routes>{renderRoutes(guestRoutes)}</Routes>;
};

export default AppGuest;
